import React, {useState, useEffect, useRef} from 'react';
import {Container, Card, Button, Row, Col, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle,} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faTumblr } from '@fortawesome/free-brands-svg-icons'
import { faQuoteLeft, faCircleInfo } from '@fortawesome/free-solid-svg-icons'
import axios from 'axios';

export default function QuoteMachine () {

    const colorRef = useRef();
    const bgRef = useRef();

    //store quote data as an object (random quote is automatically generated from API)
    const [quotes, setQuotes] = useState({});    

    //URL for quote API - Data returned in an array
    const Endpoint="https://api.quotable.io/random";

    //Set array of colors
    var colors=["red", "darkslateblue", "darkorange", "darkgreen", "purple", "black"];

    ///modal handling
    const [isOpen, setIsOpen] = React.useState(false);

    const showModal = () => {
      setIsOpen(true);
    };
  
    const hideModal = () => {
      setIsOpen(false);
    };
   
    useEffect(() => {
        getQuote();
        setColors();
        
    }, []);

    function setColors() {
        var color = Math.floor(Math.random() * colors.length);
        colorRef.current.style.color = colors[color];
        bgRef.current.style.backgroundColor = colors[color];
        document.body.style.background = colors[color];
        document.getElementById("new-quote").style.backgroundColor = colors[color];
        document.getElementById("tweet-quote").style.backgroundColor = colors[color];
        document.getElementById("tumblr-quote").style.backgroundColor = colors[color];
        };

    async function getQuote () {
        //NOTE - API that is used pulls a random quote automatically - no need to generate a random number and grab a quote
          try {
              const response = await axios.request(Endpoint);
              //populate quotes array
              setQuotes(response.data);
          } catch (error) {
              console.error(error);
          }
    }
    
    function handleClick () {
        //Generate and set bg color
        setColors();

        //Pick and set random quote
        getQuote();

    }//end handleClick

    return (
        
        <Container ref={bgRef}>

             <Card id="quote-box" ref={colorRef}>
                <Card.Header className='text-center'><h3><img src='/cmr_black_116.png' height={40}></img>  Quote Machine</h3></Card.Header>
                <Card.Body>
                    <Row>                   
                        
                        <p id="text" className="text-center"><FontAwesomeIcon icon={faQuoteLeft} size="lg" id="faicon"/> {quotes.content}</p>
                        <p className='text-end' id="author">- {quotes.author}</p>                        
                    </Row>
                </Card.Body>
                <Card.Footer id="buttons">
                    <Row>
                        <Col>
                            <div id="social">
                                <a href="http://twitter.com/intent/tweet" id="tweet-quote" className='btn btn-secondary'><FontAwesomeIcon icon={faTwitter}/></a>
                                <a href="http://tumblr.com" id="tumblr-quote" className='btn btn-warning'><FontAwesomeIcon icon={faTumblr}/></a>
                            </div>
                        </Col>

                        <Col>
                            <Button variant="primary" onClick={showModal} id="about-btn">About This Project <FontAwesomeIcon icon={faCircleInfo}/></Button>  
                        </Col>

                        <Col>
                            <Button ref={bgRef} id="new-quote" onClick={handleClick}>New Quote</Button>   
                        </Col>
                    </Row>
                    <p className='text-center mt-3'><small>This project created with React Bootstrap as a FreeCodeCamp project<br/>
                    &copy;2023 CMR Web Studio | Christian M Rapp</small></p>
                </Card.Footer>
            </Card>
            
            <Modal show={isOpen} onHide={hideModal} centered size="med">
            <ModalHeader>
                <ModalTitle>About This Project</ModalTitle>
            </ModalHeader>

            <ModalBody>
                <h6>
                    <p>This project is an assignment for the freeCodeCamp Front End Development Libraries Certification. It is supposed to be similar to the example found here: <a href="https://random-quote-machine.freecodecamp.rocks/" target="_blank">https://random-quote-machine.freecodecamp.rocks/</a>.</p>
                    <p>This project was created in React Bootstrap. It connects to a random quotes API (<a href="https://api.quotable.io/random" target="_blank">https://api.quotable.io/random</a>) and displays
                    the quote and author. </p>
                    <p>The project must meet certain criteria. A link to the freeCodeCamp CDN for testing the application has been included on this page. You can access the tests
                        provided by the CDN by clicking the 'hamburger' icon in the top left of the screen and selecting 'Random Quote Machine' in the dropdown menu that appears and then
                        clicking the 'Run Tests' button.
                    </p>
                </h6>
            </ModalBody>

            <ModalFooter>
                <Button variant='warning' onClick={hideModal}>Close Window</Button> 
            </ModalFooter>
        </Modal>
        </Container>
    );

}